import NativeNotification from 'native/Notification'

class DodoneNotification extends NativeNotification {
  constructor() {
    super(1001)
    this.dodone = null
    this.formattedTimer = null
    this.text = '...'
  }

  setDodone(dodone) {
    this.dodone = dodone
    this.setTitle(this.dodone.dodoable.name)
    this.show()
  }

  setFormattedTimer(formattedTimer) {
    this.formattedTimer = formattedTimer
    this.setText(formattedTimer)
    this.show()
  }
}

export default new DodoneNotification()
